import { defineMessages } from "react-intl";

export const messages = defineMessages({
  results: {
    id: "validation.noResults",
    defaultMessage: "No Results",
  },
  loading: {
    id: "validation.loading",
    defaultMessage: "Loading...",
  },
  desc: {
    id: "error.JsonSchemaDesc",
    defaultMessage: "Something went wrong. Please try again later.",
  },
  title: {
    id: "validation.JsonSchemaTitle",
    defaultMessage: "Uninitialized Setup or Error Occurred",
  },
  response: {
    id: "error.defaultRecord",
    defaultMessage:
      'Error: "Something unexpected happened when handling the record. Please try again later."',
  },
  saving: {
    id: "toast.saving",
    defaultMessage: "Saving...",
  },
  savingWithTitle: {
    id: "toast.savingWithTitle",
    defaultMessage: "Saving {title}.",
  },
  delete: {
    id: "toast.deleting",
    defaultMessage: "Deleting...",
  },
  import: {
    id: "toast.importing",
    defaultMessage: "Importing...",
  },
  conversion: {
    id: "toast.conversion",
    defaultMessage: "Conversion in progress...",
  },
  noDataToSave: {
    id: "error.noDataToSave",
    defaultMessage: "No data to save.",
  },
  unimplementedSetup: {
    id: "toast.unimplementedSetup",
    defaultMessage: "The {setupName} setup is not yet implemented.",
  },
  userDataFailure: {
    id: "error.userDataFailure",
    defaultMessage:
      "There was a problem loading your account. Please refresh the page or contact support if the issue continues.",
  },
  iamUserDataFailure: {
    id: "error.iamUserDataFailure",
    defaultMessage:
      "Some additional user details could not be loaded. You can continue working, but certain features may be limited.",
  },
  poGroupsRecordRequired: {
    id: "error.poGroupsRecordRequired",
    defaultMessage: "Create a PO Group before adding data in other tabs.",
  },
  unableToFetchRecord: {
    id: "error.unableToFetchRecord",
    defaultMessage:
      "Unable to fetch data. Please retry/refresh the page or contact support if the issue continues.",
  },
  fileUploadTemplateDownloaded: {
    id: "toast.fileUploadTemplateDownloaded",
    defaultMessage: "File upload Template downloaded successfully.",
  },
  fileUploadTemplateDownloadFailed: {
    id: "toast.fileUploadTemplateDownloadFailed",
    defaultMessage: "File upload Template download failed.",
  },
  minLength: {
    id: "validation.minLength",
    defaultMessage: "Value should be at least {minLength} characters long",
  },
  maxLength: {
    id: "validation.maxLength",
    defaultMessage: "Value cannot be more than {maxLength} characters long",
  },
  maxItems: {
    id: "validation.maxItems",
    defaultMessage: "Maximum {maxItems} values allowed",
  },
  pattern: {
    id: "validation.pattern",
    defaultMessage: "Value should match the pattern {pattern}",
  },
  minimum: {
    id: "validation.minimum",
    defaultMessage: "Value should be at least {minimum}",
  },
  maximum: {
    id: "validation.maximum",
    defaultMessage: "Value cannot be more than {maximum}",
  },
  multipleOf: {
    id: "validation.multipleOf",
    defaultMessage: "Value should be a multiple of {multipleOf}",
  },
  invalidDate: {
    id: "validation.invalidDate",
    defaultMessage:
      "Value should be a valid date in the format {dateFormat}, or pick a date from the calendar",
  },
  required: {
    id: "validation.required",
    defaultMessage: "This field is required.",
  },
  noFileSelected: {
    id: "error.noFileSelected",
    defaultMessage: "No file selected",
  },
  emptyFile: {
    id: "error.emptyFile",
    defaultMessage: "Empty file",
  },
  fileParseError: {
    id: "error.fileParseError",
    defaultMessage: "File parse error",
  },
  fileUploadInvalidType: {
    id: "error.fileUploadInvalidType",
    defaultMessage: "Invalid file type. Please upload XLS, XLSX, or CSV.",
  },
  fileUploadFileTooLarge: {
    id: "error.fileUploadFileTooLarge",
    defaultMessage: "File size exceeds 5 MB",
  },
  fileValidationError: {
    id: "error.fileValidationError",
    defaultMessage:
      "One or more records failed validation. Please review the data and try again.",
  },
  fileValidationSuccess: {
    id: "toast.fileValidationSuccess",
    defaultMessage: "File validated successfully.",
  },
  fileUploadSuccess: {
    id: "toast.fileUploadSuccess",
    defaultMessage: "File uploaded successfully.",
  },
});
